/// <reference types="@dynatrace/dtrum-api-types" />
import { Injectable, inject } from '@angular/core'
import { ConnectionService } from './connection.service'

@Injectable()
export class MonitoringService {
  private connectionService = inject(ConnectionService)

  public identifyUser(user: string) {
    console.log(window.dtrum)
    // Catch Dynatrace error if ever there is one. So this don't crash the whole app
    try {
      if (typeof window.dtrum !== 'undefined' && window.dtrum?.identifyUser && this.connectionService.connected) {
        window.dtrum.identifyUser(user)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  /**
   * Log an error
   */
  public error(message: string, error?: Error) {
    // Catch Dynatrace error if ever there is one. So this don't crash the whole app
    try {
      if (typeof window.dtrum !== 'undefined' && window.dtrum?.reportError && this.connectionService.connected) {
        window.dtrum.reportError(error ?? message)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  /**
   * Begin the monitoring of a custom action.
   * Don't forget to end the action with leaveAction()
   *
   * @returns the ID of the action
   */
  public enterAction(actionName: string): number | null {
    // Catch Dynatrace error if ever there is one. So this don't crash the whole app
    try {
      if (typeof window.dtrum !== 'undefined' && window.dtrum?.enterAction && this.connectionService.connected) {
        return window.dtrum.enterAction(actionName)
      }
    } catch (error) {
      console.warn(error)
    }
    return null
  }

  /**
   * End the monitoring of a custom action
   *
   * @param actionId
   */
  public leaveAction(actionId: number | null) {
    // Catch Dynatrace error if ever there is one. So this don't crash the whole app
    try {
      if (
        typeof actionId === 'number' &&
        Number.isInteger(actionId) &&
        typeof window.dtrum !== 'undefined' &&
        window.dtrum?.leaveAction &&
        this.connectionService.connected
      ) {
        window.dtrum.leaveAction(actionId)
      }
    } catch (error) {
      console.warn(error)
    }
  }
}
